import { faWifiSlash } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../modules';
import { hideTokenWarning } from '../../modules/editor';

function TokenWarning() {
  const dispatch = useDispatch();
  const { show, message } = useSelector((state: RootState) => state.editor.ui.tokenWarning);
  
  const handleClose = () => {
    dispatch(hideTokenWarning());
  };

  if (!show) return null;

  return (
    <div className="token-warning">
      <FontAwesomeIcon icon={faWifiSlash} />
      <span className="token-warning-text">{message}</span>
    </div>
  );
}

export default TokenWarning;
